import React, { useState } from "react";
import Header from "./components/Header";
import MainContent from "./components/MainContent";
import Footer from "./components/Footer";
import Portfolio from "./components/Portfolio";
import Kontakt from "./components/Kontakt";
import Reviews from "./components/Reviews";
import Projects from "./components/Projects";
import ThemeToggle from "./components/ThemeToggle";

function App() {
  const [sekcja, setSekcja] = useState("home");

  const renderujZawartosc = () => {
    if (sekcja === "portfolio") {
      return (
        <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Portfolio />
        </div>
      );
    } else if (sekcja === "kontakt") {
      return (
        <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Kontakt />
        </div>
      );
    } else if (sekcja === "projects") {
      return (
        <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Projects />
        </div>
      );
    } else if (sekcja === "") {
      return <Header zmienSekcje={setSekcja} />;
    } else {
      return (
        <>
          <MainContent />
          <Reviews />
        </>
      );
    }
  };

  return (
    <>
      <div className="App">
        <ThemeToggle />
        <Header zmienSekcje={setSekcja} />
        {renderujZawartosc()}
        <Footer zmienSekcje={setSekcja} />
        </div>  
    </>
  );
}

export default App;
